import { action } from './util';

export const WSActionType = {
  ERROR: 'WS_ERROR',
  CONNECTED: 'WS_CONNECTED',
  CONNECTING: 'WS_CONNECTING',
  DISCONNECTED: 'WS_DISCONNECTED',
  RECONNECTING: 'WS_RECONNECTING',
  RECONNECTED: 'WS_RECONNECTED',
};

export function error() {
  return action(WSActionType.ERROR, {});
}

export function connected() {
  return action(WSActionType.CONNECTED, {});
}

export function connecting() {
  return action(WSActionType.CONNECTING, {});
}

export function disconnected() {
  return action(WSActionType.DISCONNECTED, {});
}

export function reconnecting() {
  return action(WSActionType.RECONNECTING, {});
}

export function reconnected() {
  return action(WSActionType.RECONNECTED, {});
}
